export default "__VITE_ASSET__9c8bd78b__"